import {useSlider} from '@aboutyou/ui-components';
import React from 'react';

export const useTilesSlider = () => {
  const scrollWrapperRef = React.useRef<HTMLElement>(null);

  const {next, prev, scrollToSlide, nextIsActive, prevIsActive} =
    useSlider(scrollWrapperRef);

  return {
    scrollWrapperRef,
    next,
    prev,
    isNextActive: nextIsActive,
    isPrevActive: prevIsActive,
    scrollToSlide,
  };
};
